/**
 * Canonical JSON-like structure for stable fingerprinting: sorted object keys, arrays sorted by
 * `JSON.stringify` of each element (order not meaningful for Trace filter arrays such as facility codes).
 */
export function canonicalizeValueForFingerprint(value: unknown): unknown {
    if (value === null || typeof value !== 'object') {
        return value;
    }
    if (Array.isArray(value)) {
        return value
            .map((item) => canonicalizeValueForFingerprint(item))
            .sort((a, b) => {
                const sa = JSON.stringify(a);
                const sb = JSON.stringify(b);
                if (sa < sb) {
                    return -1;
                }
                if (sa > sb) {
                    return 1;
                }
                return 0;
            });
    }
    const o = value as Record<string, unknown>;
    const keys = Object.keys(o).sort();
    const out: Record<string, unknown> = {};
    for (const k of keys) {
        out[k] = canonicalizeValueForFingerprint(o[k]);
    }
    return out;
}

/** Deterministic string for comparing two fetch “inputs” (target + org + API filter). */
export function stableFingerprintString(value: unknown): string {
    return JSON.stringify(canonicalizeValueForFingerprint(value));
}
